	
	[...document.querySelectorAll( '.js-gallery' )].forEach( ( gallery ) => {
		const 	load_trigger = gallery.querySelector('.js-gallery-cta'),
				items = [...gallery.querySelectorAll( '.js-gallery-item' )],
				items_to_load_per_click = 2;

		let current_items = 4;

		if ( load_trigger ) {
			load_trigger.addEventListener( 'click', ( event ) => {
				event.preventDefault();

				for ( let i = 0; i < items_to_load_per_click; i ++ ) {
					if ( items[ current_items ] ) {
						items[ current_items ].classList.add( 'is-active' );
						current_items ++;

						if ( current_items == items.length ) load_trigger.classList.add( 'is-disabled' );
					}
				}
			} );
		}
	} );